module.exports = __webpack_public_path__ + "static/media/futureSal.742dc80d.png";